import React from 'react';
import Hero from '../components/Hero';
import ServiceCard from '../components/ServiceCard';
import Testimonials from '../components/Testimonials';
import AnimatedCounter from '../components/AnimatedCounter';
import Section from '../components/Section';
import AboutSection from '../components/AboutSection';
import site from '../content/siteContent';

export default function Home() {
  return (
    <div>
      <Hero />

      <Section>
        <AboutSection />
      </Section>

      <Section title="Our Services">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {site.services.map((s, i) => (
            <ServiceCard key={i} title={s.title}>
              {s.description}
            </ServiceCard>
          ))}
        </div>
      </Section>

      <Section title="Our Process" className="bg-sand/5">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="relative">
            <div className="card p-6 h-full">
              <div className="text-4xl font-bold text-wood mb-4">01</div>
              <h3 className="font-semibold mb-2">Consultation</h3>
              <p className="text-sm text-neutralText text-content">
                We begin with a detailed discussion of your requirements, style preferences, and
                budget constraints. Our experts visit your space to take measurements and assess
                possibilities.
              </p>
            </div>
            <div className="hidden md:block absolute top-1/2 right-0 w-8 h-0.5 bg-wood/20 translate-x-4"></div>
          </div>

          <div className="relative">
            <div className="card p-6 h-full">
              <div className="text-4xl font-bold text-wood mb-4">02</div>
              <h3 className="font-semibold mb-2">Design & Planning</h3>
              <p className="text-sm text-neutralText text-content">
                Our design team creates detailed 3D visualizations and technical drawings. We refine
                the designs based on your feedback until every detail meets your vision.
              </p>
            </div>
            <div className="hidden md:block absolute top-1/2 right-0 w-8 h-0.5 bg-wood/20 translate-x-4"></div>
          </div>

          <div className="relative">
            <div className="card p-6 h-full">
              <div className="text-4xl font-bold text-wood mb-4">03</div>
              <h3 className="font-semibold mb-2">Production</h3>
              <p className="text-sm text-neutralText text-content">
                Using state-of-the-art machinery and skilled craftsmanship, we manufacture your
                custom pieces with precision. Quality checks are performed at every stage.
              </p>
            </div>
            <div className="hidden md:block absolute top-1/2 right-0 w-8 h-0.5 bg-wood/20 translate-x-4"></div>
          </div>

          <div className="relative">
            <div className="card p-6 h-full">
              <div className="text-4xl font-bold text-wood mb-4">04</div>
              <h3 className="font-semibold mb-2">Installation</h3>
              <p className="text-sm text-neutralText text-content">
                Our experienced team handles installation with utmost care, ensuring perfect fit and
                finish. We conduct a final quality check and walkthrough with you.
              </p>
            </div>
          </div>
        </div>
      </Section>

      <Section>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          <div className="space-y-3">
            <h3 className="text-xl font-semibold">Precision. Quality. Trust.</h3>
            <p className="text-neutralText">
              We combine traditional craftsmanship with precision machinery to deliver durable and
              aesthetic interiors tailored to your space.
            </p>
          </div>

          <div className="col-span-2">
            <div className="grid grid-cols-3 gap-4">
              <div className="card p-6 text-center">
                <div className="text-sm text-muted">Projects Completed</div>
                <AnimatedCounter to={120} />
              </div>
              <div className="card p-6 text-center">
                <div className="text-sm text-muted">Years Experience</div>
                <AnimatedCounter to={20} />
              </div>
              <div className="card p-6 text-center">
                <div className="text-sm text-muted">Happy Clients</div>
                <AnimatedCounter to={50} />
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section title="What Clients Say">
        <Testimonials items={site.testimonials} />
      </Section>

      <Section title="Featured Projects">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {site.projects.slice(0, 4).map((p, idx) => (
            <div key={idx} className="card overflow-hidden">
              <picture>
                <source srcSet={p.img.replace('.jpg', '.webp')} type="image/webp" />
                <img
                  src={p.img}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-40 object-cover"
                />
              </picture>
              <div className="p-3">
                <div className="font-semibold">{p.title}</div>
                <div className="text-sm text-muted">{p.category}</div>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section className="text-center">
        <div className="card p-8">
          <h3 className="text-xl font-semibold">Ready to transform your space?</h3>
          <p className="text-neutralText mt-2">
            Get a free site visit and design consultation — we’ll bring your vision to life.
          </p>
          <a href="/contact" className="btn btn-wood mt-4">
            Book a Visit
          </a>
        </div>
      </Section>
    </div>
  );
}
